export const actionTypes = {
  create: "create",
  edit: "edit",
};
